import React, { FC } from 'react';
import { TruncatedText } from '@td-client-frontend/common';

const Truncatebale: FC = ({ children }) => {
  const childrenToRender = typeof children === 'string' ? <TruncatedText label={children} /> : children;
  return <>{childrenToRender}</>;
};

export default Truncatebale;
